import { useTranslation } from 'react-i18next';
import { useMemo, useState } from 'react';
import classnames from 'classnames';
import { useModal } from '@/providers/modal';
import Preloader from '@/components/UI/Preloader';
import { useGetLenderLoanList } from '@/query/queries/loan/useGetLenderLoanList';
import { LenderLoanCard } from '@/pages/LoansPage/components/LenderLoanCard';
import { LenderLoanDetailModal } from '@/modals/LenderLoanDetailModal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import s from './index.module.scss';

export const LenderView = () => {
  const { openSingleModal } = useModal();
  const { t } = useTranslation('loans');
  const [loan, setLoan] = useState(null);
  const [params, setParams] = useState({
    page: 1,
    limit: 20,
  });

  const onLoanOpen = loan => {
    setLoan(() => loan);
    openSingleModal(MODAL_IDS.lender_loan_detail);
  };

  const { data, isFetching } = useGetLenderLoanList(params);

  const isEmpty = !(data && data.list.length);

  const { current, history } = useMemo(() => {
    if (!data) return { current: [], history: [] };

    return data.list.reduce(
      (acc, item) => {
        item.payment_progress >= 100 ? acc.history.push(item) : acc.current.push(item);
        return acc;
      },
      { current: [], history: [] },
    );
  }, [data]);

  return (
    <div className={s.page}>
      <div className="container-inner">
        {isFetching ? (
          <Preloader style={{ height: '30vh' }} />
        ) : isEmpty ? (
          <div className={classnames(s.page__empty, 'f-16')}>{t('loans_page.no_loans')}</div>
        ) : (
          <div className={s.content}>
            {!!current.length && (
              <>
                <div className={s.header}>
                  <h1 className={classnames(s.page__title, 'f-500', 'f-42')}>
                    {t('loans_page.title')}
                  </h1>
                </div>
                <div className={s.cards}>
                  {current.map(loan => (
                    <LenderLoanCard
                      key={loan.fundraising_id}
                      loan={loan}
                      onClick={() => onLoanOpen(loan)}
                    />
                  ))}
                </div>
              </>
            )}

            {!!history.length && (
              <>
                <div className={s.header}>
                  <h1 className={classnames(s.page__title, 'f-500', 'f-42')}>
                    {t('loans_page.history')}
                  </h1>
                </div>
                <div className={s.cards}>
                  {history.map(loan => (
                    <LenderLoanCard
                      key={loan.fundraising_id}
                      loan={loan}
                      onClick={() => onLoanOpen(loan)}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <LenderLoanDetailModal loan={loan} />
    </div>
  );
};
